export class PsContractor {

    _id; // number
    _name; // string

    constructor(
        id,
        name,
    ) {
        this._id = id;
        this._name = name;
    }

    static fromAPICompany(company) {
        return new this(
            company.id,
            company.name || '',
        );
    }

    id() {
        return this._id;
    }

    name() {
        return this._name;
    }
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/document/shared/PsContractor.js